

































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { Popover } from 'element-ui';
import { namespace } from 'vuex-class';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
export interface FormData {
  task_name: string;
}

@Component({
  components: {
    AcgnPop,
    [Popover.name]: Popover
  }
})
export default class AcgnLeftMenu extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public editTaskItem: any; // 编辑项目
  @Prop() public taskItem: any; // 任务组
  @Prop() public refreshTaskList: any; // 刷新任务列表
  @TaskGroupAction private editTask: any; // 默认环节
  @TaskGroupGetter private loadings: any; // 任务组loading
  private formData: FormData = {
    task_name: ''
  };
  @Watch('visible')
  private editTaskWacth() {
    this.formData.task_name = this.editTaskItem.task_name;
  }
  get show() {
    return this.visible;
  }

  set show(v) {
    this.$emit('update:visible', v);
  }

  // 提交
  private async submit() {
    const params = {
      task_id: this.editTaskItem.id,
      name: this.formData.task_name
    };
    await this.editTask(params);
    this.$message.success('编辑成功');
    this.refreshTaskList();
    this.show = false;
  }
}
